module.exports = "<h1>Sports {{currentYear()}}</h1>\n\n"